import { render, staticRenderFns } from "./epms1020_detail_bak.vue?vue&type=template&id=74e5ebfa&scoped=true"
import script from "./epms1020_detail_bak.vue?vue&type=script&lang=js"
export * from "./epms1020_detail_bak.vue?vue&type=script&lang=js"
import style0 from "./epms1020_detail_bak.vue?vue&type=style&index=0&id=74e5ebfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e5ebfa",
  null
  
)

export default component.exports